import React from 'react';
import "./styles.css";

export default function Loader() {
    return (
        <>
            <div className="loader1"/>
            <div className="loader2"/>
        </>
    )
}